import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useLive from "../hooks/useLive";
import useLenis, { scrollToId } from "../hooks/useLenis";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { LiveBoard } from "../components/site/LiveBoard";
import { Process } from "../components/site/Process";
import { Farmers } from "../components/site/Farmers";
import { GalleryStrip } from "../components/site/GalleryStrip";
import { Faq } from "../components/site/Faq";
import { Footer } from "../components/site/Footer";
import { OrderDialog } from "../components/site/OrderDialog";
import { ChatWidget } from "../components/site/ChatWidget";

export default function Home() {
  useLenis();
  const location = useLocation();
  useEffect(() => {
    const id = location.hash.slice(1);
    if (!id) return;
    const timer = setTimeout(() => scrollToId(id), 700);
    return () => clearTimeout(timer);
  }, [location.hash]);
  const { plant, products, history, rates, closures, error } = useLive();
  const [order, setOrder] = useState({ open: false, slug: null, prefill: null });
  const openOrder = (slug = null) => setOrder({ open: true, slug: typeof slug === "string" ? slug : null, prefill: null });
  const openDraft = (draft) => {
    const slug = products.some((p) => p.slug === draft?.product_slug) ? draft.product_slug : null;
    setOrder({ open: true, slug, prefill: draft });
  };
  const totalStock = products.reduce((s, p) => s + (p?.stock_t ?? 0), 0);

  return (
    <div className="grain relative" data-testid="home-page">
      <Nav onOrder={openOrder} />
      <main>
        <Hero plant={plant} totalStock={totalStock} onOrder={openOrder} />
        <Marquee />
        <LiveBoard plant={plant} products={products} history={history} error={error} totalStock={totalStock} onOrder={openOrder} closures={closures} />
        <Process />
        <GalleryStrip />
        <Farmers rates={rates} />
        <Faq />
      </main>
      <Footer onOrder={openOrder} />
      <OrderDialog open={order.open} onOpenChange={(v) => setOrder((o) => ({ ...o, open: v }))} products={products} initialSlug={order.slug} prefill={order.prefill} closures={closures} />
      <ChatWidget onDraft={openDraft} />
    </div>
  );
}
